/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ArrowPointerSolidV6 = (props) => (
  <Icon {...props} name="Arrow Pointer Solid V6">
    <path d="M3.725 1c.177 0 .348.065.481.183l8.563 7.611a.691.691 0 0 1-.46 1.207H8.618l1.775 3.553a1 1 0 1 1-1.788.894l-1.819-3.634-2.582 2.953a.685.685 0 0 1-.518.234c-.38 0-.688-.309-.688-.716V1.725c0-.4.324-.724.724-.724z" />
  </Icon>
);

export default ArrowPointerSolidV6;
